var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "134", height: "76", viewBox: "0 0 134 76", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "DeliverableThumb"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M4 0h126a4 4 0 0 1 4 4v67.856a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#D8D8D8" }),
      React.createElement("path", { d: "M60.002 28.327a3.03 3.03 0 0 0-2.797 1.873 3.041 3.041 0 0 0 .657 3.305 3.02 3.02 0 0 0 3.297.657 3.038 3.038 0 0 0 .982-4.946 3.028 3.028 0 0 0-2.14-.89zM83.08 21H51.92A4.925 4.925 0 0 0 47 25.932v20.136A4.925 4.925 0 0 0 51.92 51h31.16A4.925 4.925 0 0 0 88 46.068V25.932A4.925 4.925 0 0 0 83.08 21zm2.46 25.068a2.464 2.464 0 0 1-2.46 2.466h-.381a3.51 3.51 0 0 0-.452-1.233L74.06 33.053c-1.128-1.957-2.973-1.957-4.1 0L63.432 44.35l-1.743-2.938c-1.151-1.944-3.038-1.944-4.19 0l-3.53 5.917c-.227.37-.384.777-.462 1.204H51.92a2.464 2.464 0 0 1-2.46-2.466V25.931a2.464 2.464 0 0 1 2.46-2.466h31.16a2.464 2.464 0 0 1 2.46 2.466v20.137z", fill: "#FFF", fillRule: "nonzero" })
    )
  );
});